import React from "react";
import { createRoot } from "react-dom/client";
import AppProviders from "@/layouts/AppProviders";
import AppRouter from "@/routes/AppRouter";
import "@style/app.style.less";
import "@style/ui-custom.less";
import "@style/responsive-layout-nav.less";
import "@style/responsive-dashboard.less";
import "@style/responsive-account.less";
import "@style/responsive-plans.less";
import "@style/responsive-signup-login.less";
import "@style/responsive-utilities.less";

createRoot(document.getElementById("root")).render(
    <AppProviders>
        <AppRouter />
    </AppProviders>
);
